import Modal from "react-bootstrap/Modal";
import uplodimg from "../../assets/images/upload.png";

function CommonModal({ show, handleClose, docData, handleChange, handleSave, currentFile, setFaaNumber, error, setError, faaNumber, isLoading, fileNames }) {
  return (
    <>
      <Modal show={show} className="modal-common" onHide={handleClose}>
        <Modal.Header closeButton>{docData?.title}</Modal.Header>
        <Modal.Body>
          <div>
            {docData?.type === "FAA" && (
              <>
                <label className="py-2">FAA Registration </label>
                <br />

                <input
                  type="text"
                  placeholder="Enter FAA certificate number"
                  className="form-control rounded-3 bg-cyan w-100"
                  name="faaRegistrationNumber"
                  value={faaNumber}
                  onChange={(e) => {
                    setFaaNumber(e.target.value)
                    setError(null);
                  }}
                />
                <br />
              </>
            )}
            <div className="upload-card">
              <label className="uploadFile">
                <img alt="" src={uplodimg} />
                <p>{currentFile ? fileNames[docData?.key] : docData?.title}</p>

                <input
                  type="file"
                  className="inputfile form-control"
                  name={docData?.key}
                  onChange={handleChange}
                  accept=".png, .jpg, .jpeg"
                />
              </label>
            </div>
            {error && <div className="text-danger text-center">{error}</div>}
            <button
              onClick={handleSave}
              className="btn btn-primary modal-blue-btn text-capitalize w-100 text-white"
              disabled={isLoading}
            >
              Send for verification
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CommonModal;
